module.exports = __webpack_public_path__ + "img/1.648d0af9.jpg";